(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["trust-numbered-row"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trust-numbered-row')) {
    class TrustNumberedRow extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.currentIndex = Math.max(0, this.items.findIndex((item) => item.hasAttribute('data-active')));
        this.interval = Math.max(2000, Number(this.getAttribute('interval')) || 3500);
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reducedMotion = this.motionQuery.matches;
        this.pointerPaused = false;
        this.focusPaused = false;
        this.editorPaused = false;
        this.abortController = new AbortController();

        const signal = this.abortController.signal;

        this.addEventListener('mouseenter', () => {
          this.pointerPaused = true;
          this.stop();
        }, { signal });
        this.addEventListener('mouseleave', () => {
          this.pointerPaused = false;
          this.start();
        }, { signal });
        this.addEventListener('focusin', () => {
          this.focusPaused = true;
          this.stop();
        }, { signal });
        this.addEventListener('focusout', () => {
          window.clearTimeout(this.focusTimer);
          this.focusTimer = window.setTimeout(() => {
            if (this.contains(document.activeElement)) return;

            this.focusPaused = false;
            this.start();
          });
        }, { signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

        this.motionQuery.addEventListener('change', (event) => {
          this.reducedMotion = event.matches;

          if (this.reducedMotion) {
            this.stop();
            this.show(this.currentIndex, false);
          } else {
            this.start();
          }
        }, { signal });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.start();
        }, { signal });

        document.addEventListener('shopify:block:select', (event) => {
          const item = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
          if (!item) return;

          this.editorPaused = true;
          this.stop();
          this.show(Number(item.dataset.index), false);
        }, { signal });

        document.addEventListener('shopify:block:deselect', () => {
          this.editorPaused = false;
          this.start();
        }, { signal });

        this.show(this.currentIndex, false);
        this.start();
      }

      disconnectedCallback() {
        window.clearTimeout(this.focusTimer);
        this.stop();
        this.abortController?.abort();
      }

      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.show(this.currentIndex + direction, false);
      }

      show(index, armProgress = true) {
        if (!this.items.length) return;

        this.currentIndex = (index + this.items.length) % this.items.length;

        this.items.forEach((item, itemIndex) => {
          const progress = item.querySelector('[data-progress]');
          const isActive = itemIndex === this.currentIndex;
          item.toggleAttribute('data-active', isActive);

          if (!progress) return;

          progress.style.transition = 'none';
          progress.style.width = itemIndex < this.currentIndex ? '100%' : '0%';
        });

        if (armProgress) this.armProgress();
      }

      armProgress() {
        if (this.reducedMotion || !this.hasAttribute('autoplay')) return;

        const progress = this.items[this.currentIndex]?.querySelector('[data-progress]');
        if (!progress) return;

        void progress.offsetWidth;
        progress.style.transition = `width ${this.interval}ms linear`;
        progress.style.width = '100%';
      }

      start() {
        if (this.reducedMotion || this.pointerPaused || this.focusPaused || this.editorPaused || !this.hasAttribute('autoplay') || this.items.length < 2 || document.hidden || this.timer) return;

        this.armProgress();
        this.timer = window.setTimeout(() => {
          this.timer = undefined;
          this.show(this.currentIndex + 1, false);
          this.start();
        }, this.interval);
      }

      stop() {
        window.clearTimeout(this.timer);
        this.timer = undefined;

        const progress = this.items[this.currentIndex]?.querySelector('[data-progress]');
        if (!progress || !progress.parentElement) return;

        const trackWidth = progress.parentElement.getBoundingClientRect().width;
        const progressWidth = progress.getBoundingClientRect().width;
        progress.style.transition = 'none';

        if (trackWidth > 0) progress.style.width = `${(progressWidth / trackWidth) * 100}%`;
      }
    }

    customElements.define('trust-numbered-row', TrustNumberedRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-statement-card"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('trust-statement-card')) {
    class TrustStatementCard extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.icons = Array.from(this.querySelectorAll('[data-icon]'));
        this.progress = this.querySelector('[data-progress]');
        this.currentIndex = Math.max(0, this.slides.findIndex((slide) => slide.dataset.state === 'active'));
        this.interval = Math.max(2000, Number(this.getAttribute('interval')) || 3500);
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reducedMotion = this.motionQuery.matches;
        this.pointerPaused = false;
        this.focusPaused = false;
        this.editorPaused = false;
        this.abortController = new AbortController();

        const signal = this.abortController.signal;

        this.addEventListener('mouseenter', () => {
          this.pointerPaused = true;
          this.stop();
        }, { signal });
        this.addEventListener('mouseleave', () => {
          this.pointerPaused = false;
          this.start();
        }, { signal });
        this.addEventListener('focusin', () => {
          this.focusPaused = true;
          this.stop();
        }, { signal });
        this.addEventListener('focusout', () => {
          window.clearTimeout(this.focusTimer);
          this.focusTimer = window.setTimeout(() => {
            if (this.contains(document.activeElement)) return;

            this.focusPaused = false;
            this.start();
          });
        }, { signal });
        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

        this.motionQuery.addEventListener('change', (event) => {
          this.reducedMotion = event.matches;

          if (this.reducedMotion) {
            this.stop();
            this.show(this.currentIndex, false);
          } else {
            this.start();
          }
        }, { signal });

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.start();
        }, { signal });

        document.addEventListener('shopify:block:select', (event) => {
          const slide = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
          if (!slide) return;

          this.editorPaused = true;
          this.stop();
          this.show(Number(slide.dataset.index), false);
        }, { signal });

        document.addEventListener('shopify:block:deselect', () => {
          this.editorPaused = false;
          this.start();
        }, { signal });

        this.show(this.currentIndex, false);
        this.start();
      }

      disconnectedCallback() {
        window.clearTimeout(this.focusTimer);
        this.stop();
        this.abortController?.abort();
      }

      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        this.show(this.currentIndex + direction, false);
      }

      show(index, armProgress = true) {
        if (!this.slides.length) return;

        const count = this.slides.length;
        this.currentIndex = (index + count) % count;
        const previousIndex = (this.currentIndex + count - 1) % count;

        this.slides.forEach((slide, slideIndex) => {
          let state = 'next';
          if (slideIndex === this.currentIndex) state = 'active';
          else if (slideIndex === previousIndex) state = 'previous';

          slide.dataset.state = state;
          slide.setAttribute('aria-hidden', slideIndex === this.currentIndex ? 'false' : 'true');
        });

        this.icons.forEach((icon, iconIndex) => {
          icon.dataset.state = iconIndex === this.currentIndex ? 'active' : 'next';
        });

        this.paintProgress(armProgress);
      }

      paintProgress(armed) {
        if (!this.progress || !this.slides.length) return;

        const start = (this.currentIndex / this.slides.length) * 100;
        const end = ((this.currentIndex + 1) / this.slides.length) * 100;
        this.progress.style.transition = 'none';
        this.progress.style.width = `${start}%`;

        if (!armed || this.reducedMotion || !this.hasAttribute('autoplay')) return;

        void this.progress.offsetWidth;
        this.progress.style.transition = `width ${this.interval}ms linear`;
        this.progress.style.width = `${end}%`;
      }

      start() {
        if (this.reducedMotion || this.pointerPaused || this.focusPaused || this.editorPaused || !this.hasAttribute('autoplay') || this.slides.length < 2 || document.hidden || this.timer) return;

        this.paintProgress(true);
        this.timer = window.setTimeout(() => {
          this.timer = undefined;
          this.show(this.currentIndex + 1, false);
          this.start();
        }, this.interval);
      }

      stop() {
        window.clearTimeout(this.timer);
        this.timer = undefined;

        if (!this.progress || !this.progress.parentElement) return;

        const trackWidth = this.progress.parentElement.getBoundingClientRect().width;
        const progressWidth = this.progress.getBoundingClientRect().width;
        this.progress.style.transition = 'none';

        if (trackWidth > 0) this.progress.style.width = `${(progressWidth / trackWidth) * 100}%`;
      }
    }

    customElements.define('trust-statement-card', TrustStatementCard);
  }

  } catch(e) { console.error(e); }
})();
})();
